module.exports = __webpack_public_path__ + "static/media/InsN.1340bcc3.png";